export function loadWorkbenchBuild() {
  return import("@/pages/WorkspaceSimEdit").then((module) => ({
    default: module.WorkspaceSimEdit,
  }));
}
